



































































































































































































import { PMNDemande_Statut } from '@/domain/PMNDemande_Statut'
import { PMNModele_Input, TypeInput } from '@/domain/PMNModele'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import PMNMixin from './PMN-ClientMixin'
import PMNDatatableMixin from '../../PMNDatatableMixin'

export default mixins(PMNMixin, mobileTypeMixin, PMNDatatableMixin).extend({
    data() {
        return {
            menusDates: [],
            headers: [
                { text: 'Date de création', value: 'dateCreation' },
                { text: 'Statut', value: 'statut' }
            ],
            options: { sortBy: ['dateCreation'], sortDesc: [false] },
            isUploading: false,
            files: [] as File[],
            messageConfirmationUpload: null as null | string
        }
    },
    computed: {
        isEditing() {
            return this.PMNDemandeModeleUtilise && this.PMNDemandeEditee
        }
    },
    methods: {
        isNotEditing() {
            this.PMNDemandeModeleUtilise = null
            this.PMNDemandeEditee = null
        },
        isEnCoursDeRedaction(statut: PMNDemande_Statut) {
            return statut == PMNDemande_Statut.EnCoursRedaction
        },
        isText(input: PMNModele_Input) {
            return input.typeInput == TypeInput.Texte || input.typeInput == TypeInput.CodePostal
        },
        isNumber(input: PMNModele_Input) {
            return input.typeInput == TypeInput.Nombre
        },
        isDate(input: PMNModele_Input) {
            return input.typeInput == TypeInput.Date
        },
        isTelephone(input: PMNModele_Input) {
            return input.typeInput == TypeInput.Telephone
        },
        isMail(input: PMNModele_Input) {
            return input.typeInput == TypeInput.Email
        },
        isCaseACocher(input: PMNModele_Input) {
            return input.typeInput == TypeInput.ListeProposition
        },
        validerSignature() {
            if (!this.demandeSignature) return

            const canvas = this.$refs.signature as HTMLCanvasElement
            if (!canvas) return

            this.$loader.go()
            this.$http
                .api(`PMNClient/envoyer-demande`)
                .post({ id: this.demandeSignature.id, signature: canvas.toDataURL() })
                .then(() => {
                    this.getAllDemandePMN()
                    this.dialog.close()
                    this.demandeSignature = null
                    this.$swal.toast.success('Votre PMN a bien été envoyée')
                })
                .catch(x => {
                    this.$loader.stop()
                    this.$swal.toast.errorApi(x)
                })
        },
        envoyer() {
            this.$loader.go()
            this.save(true)
        },
        enregistrerCommeBrouillon() {
            this.$loader.go()
            this.save(false)
        },
        ajouterFichier() {
            if (!this.files.length) return

            const formData = new FormData()
            for (const f of this.files) {
                formData.append('files', f, f.name)
            }
            console.log(formData)

            this.messageConfirmationUpload = ''
            this.$loader.go()
            this.$http
                .api(`PMNClient/file`)
                .post(formData)
                .then(x => {
                    this.files = []
                    this.messageConfirmationUpload = 'La PMN a été correctement envoyée.'
                    this.$swal.toast.success()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    }, 
})
